import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type BulkGroup } from '../../entity/api/bulk-group';
import { createBasicStoreState } from './basic-store';

type TModel = BulkGroup;

/**
 * Bulk Groups Zustand Store
 *
 * This store now only provides:
 * - Basic store methods (clearStore, updateToStore, updateMultipleToStore, etc.) for socket updates
 * - Sync state for socket handlers
 *
 * For data fetching and mutations, use TanStack Query hooks from bulk-groups-queries.ts:
 * - useBulkGroupsList()
 * - useBulkGroupById(id)
 * - useBulkGroupsByBrandId(brandId)
 * - useBulkGroupsByOrgId(orgId)
 * - useCreateBulkGroup()
 * - useUpdateBulkGroup()
 * - useRemoveBulkGroup()
 *
 * For cache access, use helpers from bulk-groups-queries.ts:
 * - getBulkGroupFromCache(queryClient, id)
 * - getBulkGroupsListFromCache(queryClient)
 * - getBulkGroupsByBrandIdFromCache(queryClient, brandId)
 */
type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'bulk-groups' }
  )
);
